const Element = require('./model/element')
const ElementList = require('./model/element_list')
const Form = require('./model/form')
const FormView = require('./view/form_view')
const ElementView = require('./view/element_view')
const InputViewTypes = require('./view/input_view_types')
const LabelView = require('./view/label_view')

const FreeForm = {
    Element,
    ElementList,
    Form,
    FormView,
    ElementView,
    InputViewTypes,
    LabelView,
}

module.exports = FreeForm
